import { render, staticRenderFns } from "./RechargeOrderResult.vue?vue&type=template&id=4528aff1&scoped=true&"
import script from "./RechargeOrderResult.vue?vue&type=script&lang=js&"
export * from "./RechargeOrderResult.vue?vue&type=script&lang=js&"
import style0 from "./RechargeOrderResult.vue?vue&type=style&index=0&id=4528aff1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528aff1",
  null
  
)

export default component.exports